import { render, staticRenderFns } from "./AsyncSelect.vue?vue&type=template&id=b45a9bd2&scoped=true&"
import script from "./AsyncSelect.vue?vue&type=script&lang=js&"
export * from "./AsyncSelect.vue?vue&type=script&lang=js&"
import style0 from "./AsyncSelect.vue?vue&type=style&index=0&id=b45a9bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45a9bd2",
  null
  
)

export default component.exports